import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import ResponsiveLayout from '../components/Layout/ResponsiveLayout';
import MobileLayout from '../components/Layout/MobileLayout';
import {
  USER_ROLES,
  canInviteCarePartner,
  canInviteCaregiver,
  canInviteTherapist,
} from '../constants/roles';
import { useRole } from '../contexts/RoleContext';
import RolePermissionsGuide from '../components/CareTeam/RolePermissionsGuide';
import {
  getRoleGuideCopy,
  getRolePermissionGuideItems,
} from '../components/CareTeam/rolePermissionsGuideData';
import { useChildContext } from '../contexts/ChildContext';

const InviteRoleSelectionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { currentChildId } = useChildContext();
  const { childrenWithAccess, getUserRoleForChild } = useRole();
  // Get childId from either state (new way) or searchParams (fallback)
  const childId = location.state?.childId || searchParams.get('childId') || currentChildId || '';
  const requesterRole = childId ? getUserRoleForChild?.(childId) || null : null;
  const selectedChild = childId
    ? childrenWithAccess.find((child) => child.id === childId) || null
    : null;
  const roleGuideItems = getRolePermissionGuideItems(selectedChild || {});
  const guideCopy = getRoleGuideCopy(selectedChild || {});

  const availableRoleOptions = roleGuideItems.filter((option) => {
    if (!requesterRole) return true;
    if (option.role === USER_ROLES.CARE_PARTNER) return canInviteCarePartner(requesterRole);
    if (option.role === USER_ROLES.CAREGIVER) return canInviteCaregiver(requesterRole);
    if (option.role === USER_ROLES.THERAPIST) return canInviteTherapist(requesterRole);
    return false;
  });

  const handleRoleSelect = (option) => {
    navigate(option.route, childId ? { state: { childId } } : undefined);
  };

  const inviteContent = (
    <RolePermissionsGuide roleOptions={availableRoleOptions} guideCopy={guideCopy} onRoleSelect={handleRoleSelect} />
  );

  return (
    <ResponsiveLayout
      pageTitle="Who Can Do What"
      showBottomNav={false}
      showFab={false}
      customTablet={
        <MobileLayout pageTitle="Who Can Do What" showBottomNav={false} showFab={false}>
          {inviteContent}
        </MobileLayout>
      }
    >
      {inviteContent}
    </ResponsiveLayout>
  );
};

export default InviteRoleSelectionPage;
